export enum DialogSize {
   Small = 'dialog-sm',
   Medium = 'dialog-md',
   Large = 'dialog-lg',
}
